import { DatePicker, Select, Option, CheckboxGroup, CheckboxButton, Popover, Input, Button, Table, TableColumn } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import MedalDecider from '@/components/shared/medals/club/decider/decider.vue';

const request = new ResourceSvc();

export default {
    name: 'ClubsWidget',
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [CheckboxButton.name]: CheckboxButton,
        [CheckboxGroup.name]: CheckboxGroup,
        [Popover.name]: Popover,
        [Input.name]: Input,
        [Button.name]: Button,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        'medal-decider': MedalDecider
    },
    data() {
        return {
            isProcessing: false,
            clubs: [],
            allCounties: [],
            isJunior: [],
            selectedCounty: '',
			juniorAnswer: [{ label: 'Yes', id: 0 }],
        }
    },
    watch: {
        selectedCounty: {
            handler(newVal, oldVal) {
                this.load();
            },
            deep: true
        },
    },
    computed: {
    },
    methods: {
        openlink(link) {
            if (link != null) {
                window.open(link, '_blank');
            }
        },
        isInArray(array, value) {
            if (!array) {
                return false;
            }
            return array.includes(value);
        },
        load(isJunior) {
            const self = this;
            if (self.isProcessing) {
                return;
            }
            self.isProcessing = true;
            request.getClubsListByFilter(isJunior == undefined ? false : isJunior, self.selectedCounty)
                .then(res => {
                    if (res && res.body && res.body.isSuccess) {
                        self.isProcessing = false;
                        self.clubs = res.body.outputData.clubs;
                        self.allCounties = res.body.outputData.allCounties;
                    }
                    else {
                        //self.$showError(res && res.body && res.body.message ? res.body.message : null, 5000);
                        self.isProcessing = false;
                        self.clubs = [];
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError(5000);
                    });
        },
    },
    mounted() {
        this.load();
    },
    beforeCreate() {
        const css = `#launcher {
    display: none !important;
}
    `;
        this.styleTag = document.createElement('style');
        this.styleTag.appendChild(document.createTextNode(css));
        document.head.appendChild(this.styleTag);

    },
    destroyed() {
        this.styleTag.remove();
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/pages/clubs-widget/clubs-widget.js